<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <div class="container-box">
          <input type="checkbox" @click="ShowParent()" v-model="checkedParent" /> <label class="text-white">Show Parent</label>
          <div v-if="checkedParent">
        <label style="text-align: left; left: 0" class="custom-label-note"
          >Enter Name</label
        >
        <br />
        <input
          type="text"
          v-model="name"
          placeholder="Enter your Name"
          class="custom-input-user"
        />
        <br />
        <br />
        <label style="text-align: left; left: 0" class="custom-label-note"
          >Enter Email</label
        >
        <br />
        <input
          type="text"
          v-model="email"
          placeholder="Enter your Email"
          class="custom-input-user"
        />
        <br />
        <br />
        <label style="text-align: left; left: 0" class="custom-label-note"
          >Enter Phone</label
        >
        <br />
        <input
          type="text"
          v-model="phone"
          placeholder="Enter your Phone"
          class="custom-input-user"
        />
        <br />
        <br />
        <label style="text-align: left; left: 0" class="custom-label-note"
          >Enter Password</label
        >
        <br />
        <input
          type="password"
          v-model="password"
          placeholder="Enter your Password"
          class="custom-input-user"
        />
       
        <br />
        <label style="text-align: left; left: 0" class="custom-label-note mt-3"
          >If you are from a country other than Malaysia, kindly choose your country</label
        >
        <br />
        <v-select
          v-model="SelectedCountry"
          :options="filteredCountries"
          label="CountryName"
          placeholder="--Please Select Country--"
          
        >
        </v-select>
        </div>
        <br /><br />
        <input type="checkbox" @click="AddNew()" v-model="checked" />
        <label class="text-white"> Register Student</label> <br />
        <br />
        <div v-if="checked">
         <label class="text-white"> Student Info</label>
          <br /> <br />
          <label style="text-align: left; left: 0" class="custom-label-note"
            >Enter Student Name</label
          >
          <br />
          <input
            type="text"
            v-model="FullName"
            placeholder="Enter Student Name"
          />
          <br />
          <br />
          <label style="text-align: left; left: 0" class="custom-label-note"
            >Enter Age</label
          >
          <br />
          <input type="text" placeholder="Enter Your Age" v-model="Age" />
           <br />
          <br />
          <label style="text-align: left; left: 0" class="custom-label-note"
            >Select Grade</label
          >
          <br />
            <v-select
              v-model="SelectedGrade"
              :options="grades"
              label="gradeName"
              placeholder="--Please Select Grade--"
            ></v-select>

 <br /> 
          <label style="text-align: left; left: 0" class="custom-label-note"
            >Select Gender</label
          >
          <br />
            <input type="radio" v-model="gender" value="Female" />
            <span class="text-white"> Female</span>
            <input
              type="radio"
              class="text-dark ml-3"
              v-model="gender"
              value="Male"
            />
            <span class="text-white"> Male</span>
          <br /><br />
        </div>
        <div style="bottom: 100px; position: absolute">
          <div v-if="this.Error == true" class="ml-1 mr-1">
            <CAlert show color="danger" class="custom-error-message"
              >The credentials entered is incorrect.Please <br />try
              again.</CAlert
            >
          </div>
        </div>
          <CButton
        color="info"
        class="custom-btn-login-active mt-3 mb-3"
        v-on:click="InsertSignUp"
        >{{ buttonLabel }}</CButton
      >
      </div>
    </CContainer>
    <div class="bottom-center">
      <!-- <CButton
        color="info"
        class="custom-btn-login-active mt-5"
        v-on:click="InsertSignUp"
        >Sign Up</CButton
      > -->
      <br />
      <br />
    </div>
    <div class="header-top mb-5">Sign Up</div>
    <div class="header-left" @click="GoBack()">
      <img src="../assets/img/icon/VectorLeft.svg" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>


<script>
import Vue from "vue";
import vSelect from "vue-select";
import backgroundUrl from "../assets/img/bgApps.png";
  Vue.component("v-select", vSelect);
  import "vue-select/dist/vue-select.css";
  import "vue-select/src/scss/vue-select.scss";
export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
      name: "",
      email: "",

      phone: "",
      password: "",
      Error: false,
      Message: "",
      noteModal: true,

      backgroundUrl,
      SuccessMessage: false,
      ErrorMessage: false,

      checked: false,
      checkedParent: true,
      TuitionCenterCode: "2075",
      Age: "",
      ParentName: "",
      Age: "",
      gender: "",
      MainContactNumber: "",
      FullName: "",
      grades: [],
      country: [],

      SelectedGrade: "",
      buttonLabel: "Sign Up",

      SelectedCountry: "",
    };
  },
  async mounted() {
    this.GetGrade();
    this.GetCountry();
  },
  computed: {
    filteredCountries() {
      return this.country.filter((option, index) => index !== 12);
    },
  },
  methods: {
    GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    GoToHomepage() {
      window.open("https://pickiddo.com", "_self");
    },
    GoToLogin() {
      this.$router.push("Login");
    },
    InsertSignUp() {
      var currentUrl = window.location.hash;

      let id = currentUrl;
      var join = "codeId";
      var quiz = "quizId";
      var refer = "referId";

      let quizID = id.includes(quiz);
      let codeid = id.includes(join);
      let referID = id.includes(refer);

      console.log("id" + id);
      console.log("quizId" + quizID);
      console.log("codeid" + codeid);
      console.log("REFER" + referID);

      this.buttonLabel = "Processing";

      const formData = new FormData();

      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("password", this.password);

      formData.append("userType", "parent");
      formData.append("phone", this.phone);
      if(this.SelectedCountry.Id == null)
      {
        formData.append("countryId", 0);
      }
      else
      {
        formData.append("countryId", this.SelectedCountry.Id);
      }

      return this.$API
        .post(this.$SignUp, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Message = response.data.Message;
            this.userId = response.data.UserId;

            if (this.FullName == "") {
              this.SuccessMessage = true;
              this.RegisterStudent(this.UserID);
              this.GoToLogin(this.email, this.password);

              // if (quizID == true) {
              //   window.open(
              //     "../OnlineClass/#/SignUp?targetUrl=%2FQuizStudent%3FquizId%3D" +
              //       this.$route.query.quizId,
              //     "_self"
              //   );
              // }
              // if (codeid == true) {
              //   window.open(
              //     "../OnlineClass/#/SignUp?targetUrl=%2FJoinGroup%3FcodeId%3D" +
              //       this.$route.query.codeId,
              //     "_self"
              //   );
              // }
              // if (referID == true) {
              //   this.UserID = response.data.UserId;
              //   this.InsertReferralProgram(this.UserID);
              //   this.$router.push("Login");
              // }
              // if (quizID == false && codeid == false && referID == false) {
              //   this.$router.push("Login");
              // }
            } else {
              this.UserID = response.data.UserId;
              this.RegisterStudent(this.UserID);
              this.GoToLogin(this.email, this.password);
            }
          } else {
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        });
    },
    async AddNew() {
      this.formNew = true;
      this.checkedParent = false;
    },
    async ShowParent() {
      this.formParent = true;
    },
    async GetCountry() {
        this.$API
          .get(this.$ListCountry)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.country = response.data;
            }
          });
      },
    RegisterStudent() {
      var currentUrl = window.location.hash;

      let id = currentUrl;
      var join = "codeId";
      var quiz = "quizId";
      var refer = "referId";

      let quizID = id.includes(quiz);
      let codeid = id.includes(join);
      let referID = id.includes(refer);

      console.log("id" + id);
      console.log("quizId" + quizID);
      console.log("codeid" + codeid);
      console.log("REFER" + referID);

      const formData = new FormData();

      formData.append("Name", this.FullName);
      formData.append("ParentPhoneNumber", this.phone);
      formData.append("Grade", this.SelectedGrade.gradeName);
      formData.append("ParentName", this.name);
      formData.append("ParentEmail", this.email);
      if(this.SelectedCountry.Id == null)
      {
        formData.append("countryId", 0);
      }
      else
      {
        formData.append("countryId", this.SelectedCountry.Id);
      }
     

      return this.$API
        .post(this.$RegisterManualStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            if (response.data > 0) {
              this.SuccessMessage = true;

              //  if (quizID == true) {
              //     window.open(
              //       "../OnlineClass/#/Login?targetUrl=%2FQuizStudent%3FquizId%3D" +
              //         this.$route.query.quizId,
              //       "_self"
              //     );
              //   }
              //   if (codeid == true) {
              //     window.open(
              //       "../OnlineClass/#/Login?targetUrl=%2FJoinGroup%3FcodeId%3D" +
              //         this.$route.query.codeId,
              //       "_self"
              //     );
              //   }
              //   if (referID == true) {
              //     this.InsertReferralProgram(UserID);
              //     this.$router.push("Login");
              //   }

              //   if (quizID == false && codeid == false && referID == false) {
              //     this.$router.push("Login");
              //   }
            } else {
              this.ErrorMessage = true;
            }
          } else if (response.status == 500) {
            this.ErrorMessageNotComplete = true;
          } else {
            this.ErrorMessageNotComplete = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.ErrorMessageNotComplete = true;
          }
        });
    },
    GoToLogin(email, password) {
      var currentUrl = window.location.hash;

      let id = currentUrl;
      var join = "codeId";
      var quiz = "quizId";
      var refer = "referId";

      let quizID = id.includes(quiz);
      let codeid = id.includes(join);
      let referID = id.includes(refer);

      console.log("id" + id);
      console.log("quizId" + quizID);
      console.log("codeid" + codeid);
      console.log("REFER" + referID);
      this.Error = false;

      const formData = new FormData();

      if (email === "" || password === "") {
        this.Error = true;
        this.Message = "Please fill up the form !";
      } else {
        formData.append("Email", email);
        formData.append("Password", password);

        this.$API
          .post(this.$LoginToken, formData, { withCredentials: true })
          .then((response) => {
            if (response.data.status === 400) {
              this.Loading = false;
              this.Message = response.data.message;
              this.Error = true;
            }
            if (response.status == 200) {
              if (response.data.status !== 400) {
                // if (
                //   this.$route.query.targetUrl != "" &&
                //   (this.$route.query.targetUrl != null) &
                //     (this.$route.query.targetUrl != undefined)
                // ) {
                //   this.$router.push(this.$route.query.targetUrl);
                // } else {
                //   this.GoToHome();
                // }

                if (quizID == true) {
                  window.open(
                    "../OnlineClass/#/QuizStudent?quizId=" +
                      this.$route.query.quizId,
                    "_self"
                  );
                }
                if (codeid == true) {
                  window.open(
                    "../OnlineClass/#/JoinGroup?codeId=" +
                      this.$route.query.codeId,
                    "_self"
                  );
                }
                if (referID == true) {
                  this.InsertReferralProgram(UserID);
                  this.$router.push("Login");
                }

                if (quizID == false && codeid == false && referID == false) {
                  this.$router.push("ExistingUser");
                }
              } else {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;
              }
            } else {
              this.Loading = false;
              this.Error = true;
              this.Message = response.data.message;
            }
          })
          .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },
    InsertReferralProgram(UserID) {
      const formData = new FormData();

      formData.append("ReferId", this.$route.query.referId);
      formData.append("UserId", UserID);

      return this.$API
        .post(this.$InsertReferProgram, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Message = response.data.Message;
            this.UserID = response.data.UserId;
            this.SuccessMessage = true;
          } else {
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        });
    },
    GoBack() {
      this.$router.back();
    },
  },
};
</script> -->
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}

.container-box {
  max-width: 335px;
  margin: 0 auto;
}

input[type="text"] {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
  -webkit-text-fill-color: white !important;
}

input[type="password"] {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
  -webkit-text-fill-color: white !important;
}
input[type="text"] .custom-user-input-select {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
}
.custom-width-listphone {
  width: 24px;
  height: 24px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

input[type="radio"] {
  opacity: 1;
}
select {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  color: #e0e0e0;
}

input ::placeholder {
  color: #fff;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
.custom-user-input-select {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
.custom-user-inputs {
  display: flex;
  display: -ms-flexbox;
  /* display: -webkit-box; */
  /* -webkit-box-pack: center; */
  -ms-flex-pack: center;
  justify-content: center;
  /* -webkit-box-orient: horizontal; */
  /* -webkit-box-direction: normal; */
  -ms-flex-flow: row nowrap;
  /* flex-flow: row nowrap; */
  width: -webkit-fill-available;
}
input:-webkit-autofill {
  -webkit-background-clip: text;
  -webkit-text-fill-color: white !important;
}

.custom-error-message {
  background: #f85954;
  color: #fff;
  bottom: 20px;
  left: 0px;
  right: 0px;
}
</style>